module.exports = __webpack_public_path__ + "resources/img/img_hi_psm2_en.e28b41ce0ed1e253d622cf63b39363d9.png";